import React from 'react';

function WaitingForHostDialog() {
    return (
        <div className="waitingForHostDialogWrapper">
            <p className="waitingForHostDialogText">Game will resume, when the host reopens Justly</p>
        </div>
    );
};

export default WaitingForHostDialog;